"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var core_1 = require("@athena-portal/core");
var FontAwesomeIcon_1 = require("./FontAwesomeIcon");
var index_1 = require("./index");
var i18n_1 = require("./i18n");
var react_router_dom_1 = require("react-router-dom");
var SideMenuItem = /** @class */ (function (_super) {
    __extends(SideMenuItem, _super);
    function SideMenuItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            tooltipOpen: false
        };
        _this.toggleTooltip = _this.toggleTooltip.bind(_this);
        _this.execCommand = _this.execCommand.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    /**
     * Executes the command for the current item
     */
    SideMenuItem.prototype.execCommand = function (evt) {
        evt.stopPropagation();
        evt.preventDefault();
        this.handleClick();
        this.commandManager.exec(this.props.command);
    };
    SideMenuItem.prototype.handleClick = function () {
        this.props.onClick && this.props.onClick();
    };
    SideMenuItem.prototype.render = function () {
        var _this = this;
        var linkProps = {};
        if (this.props.command) {
            // If command passed, exec command
            linkProps.to = "javascript:void(0)";
            linkProps.onClick = this.execCommand;
        }
        else {
            // Else open link
            linkProps.to = this.props.path;
            linkProps.onClick = this.handleClick;
        }
        return (React.createElement(React.Fragment, { key: this.props.id },
            React.createElement(react_router_dom_1.NavLink, __assign({ activeClassName: "active", exact: true, className: "list-group-item list-group-item-action lvl-".concat(this.props.level, " ").concat(this.props.type || "", " ").concat(this.props.className || "") }, linkProps, { "data-order": this.props.order }),
                React.createElement("span", { className: "icon", id: "item_".concat(this.props.id) },
                    React.createElement(FontAwesomeIcon_1.default, { icon: this.props.icon || "dot-circle" }),
                    React.createElement(i18n_1.FormattedMessage, { id: this.props.titleId, defaultMessage: this.props.title }, function (formattedTitle) {
                        return React.createElement(index_1.Tooltip, { placement: "right", target: "item_".concat(_this.props.id), isOpen: _this.state.tooltipOpen, toggle: _this.toggleTooltip, boundariesElement: "viewport" }, formattedTitle);
                    })),
                React.createElement("span", { className: "title" },
                    React.createElement(i18n_1.FormattedMessage, { id: this.props.titleId, defaultMessage: this.props.title })),
                (this.props.notifications && this.props.notifications > 0) ?
                    React.createElement("span", { className: "notifications" }, this.props.notifications) : ""),
            this.props.childs && this.props.childs.map(function (child) {
                return React.createElement(SideMenuItem, __assign({ key: child.id }, child, { onClick: _this.props.onClick, level: _this.props.level + 1 }));
            })));
    };
    /**
     * Toggles tooltip for menu item
     * @id: Id of the element
     */
    SideMenuItem.prototype.toggleTooltip = function () {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.CommandManager),
        __metadata("design:type", Object)
    ], SideMenuItem.prototype, "commandManager", void 0);
    return SideMenuItem;
}(React.Component));
exports.default = SideMenuItem;
//# sourceMappingURL=SideMenuItem.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/SideMenuItem.js
// module id = 2123
// module chunks = 0